const CopyIcon = ({ color = 'currentColor' }) => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.75 4.80952H11V11H4.5V7.66667M7.75 4.80952H4.5V7.66667M7.75 4.80952V1H1V7.66667H4.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CopyIcon;
